<app-auth-view>
  <ng-container slot="title">Geen toegang</ng-container>
  <ng-container slot="message">
    Je account heeft nog geen rol toegewezen gekregen, waardoor je geen enkel
    onderdeel van het dashboard kunt gebruiken. Neem contact op met een beheerder
    om een rol te laten toewijzen.
  </ng-container>

  <ng-container slot="content">
    <button mat-flat-button class="mt-10" (click)="logout()">Uitloggen</button>
  </ng-container>
</app-auth-view>
